module.exports = __webpack_public_path__ + "img/1_2-parco-1.cc75b991.png";